module.exports = __webpack_public_path__ + "img/8.b6af6957.png";